export default __webpack_public_path__ + "static/media/poster221227.0dac6ae4.jpg";